// ScrollToButton.jsx

import { scrollTo } from "helpers/scroll";
import React from "react";
import { useTranslation } from "next-i18next";
import Image from "next/image";

interface ScrollToButtonInput {
  toId: string;
  toRef: any;
  duration: number;
  className: string;
  content?: string;
  adjustPosition?: number;
}

const ScrollToButton = (input: ScrollToButtonInput) => {
  const { t } = useTranslation("about");
  const { toId, toRef, duration, className, content, adjustPosition } = input;
  const handleClick = () => scrollTo({ id: toId, ref: toRef, duration, adjustPosition });

  return (
    <div className={className}>
      {!content ? (
        <Image
          onClick={handleClick}
          width={45}
          height={45}
          src={"/images/scroll-to.svg"}
          alt={"scroll-to-icon" + "logo"}
          className="cursor-pointer"
        />
      ) : (
        <p>{t(content)}</p>
      )}
    </div>
  );
};

export default ScrollToButton;
